export const BILLINGS_TABLE_HEADERS_AGENCY = [
  { label: 'Agency Name', key: 'agency_name', search: true, sort: true },
  { label: 'Billing Status', key: 'billing_status', search: true, sort: true },
  { label: 'MESSAGE', key: 'message', search: false, sort: false },
  { label: 'TOTAL LEADS', key: 'leads_count', search: false, sort: false },
  {
    label: 'TOTAL BILLED AMOUNT',
    key: 'total_billed_amount',
    search: false,
    sort: false,
  },
  { label: 'DISCOUNT', key: 'discount', search: false, sort: false },
  { label: 'CREDITS', key: 'credits', search: false, sort: false },
  {
    label: 'SCHEDULE+',
    key: 'schedule_product_bill_amount',
    search: false,
    sort: false,
  },
  {
    label: 'INOVICE PDF',
    key: 'invoice_pdf_url',
    search: false,
    sort: false,
  },
  { label: 'REPORT CSV', key: 'report_csv_url', search: false, sort: false },
  {
    label: 'Approve Bill',
    key: 'approved',
    search: false,
    sort: false,
  },
];

export const BILLINGS_TABLE_HEADERS_GROUP = [
  { label: 'Group Name', key: 'group_name', search: true, sort: true },
  { label: 'Agency Name', key: 'agency_name', search: true, sort: true },
  {
    label: 'Group Total Bill',
    key: 'group_total_amount',
    search: true,
    sort: true,
  },
  { label: 'Billing Status', key: 'billing_status', search: true, sort: true },
  { label: 'Total Leads', key: 'leads_count', search: true, sort: true },
  {
    label: 'Total Billed Amount',
    key: 'total_billed_amount',
    search: true,
    sort: true,
  },
  { label: 'Discount', key: 'discount', search: true, sort: true },
  { label: 'Credits', key: 'credits', search: true, sort: true },
  {
    label: 'Invoice Pdf',
    key: 'invoice_pdf_url',
    search: false,
    sort: true,
  },
  { label: 'Report CSV', key: 'report_csv_url', search: false, sort: true },
  {
    label: 'Approve Bill',
    key: 'approved',
    search: true,
    sort: true,
  },
];
